import { Alert, Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import AddMembersPanel from "src/components/ChatAutomations/AddMembersPanel";
import RecentSendsPanel from "src/components/ChatAutomations/RecentSendsPanel";
import SendMessagesPanel from "src/components/ChatAutomations/SendMessagesPanel";

/**
 * Chat Automations — staff-only tools for reaching members in bulk.
 *
 * These send for real, through the admin-only resolver and Stream. Recent Sends
 * is the safety net: every bulk send is recorded with the id of each message it
 * sent, so one that shouldn't have gone out can be deleted again within a day.
 */

type AutomationTab = "send" | "add" | "recent";

const ChatAutomationsPage: React.FC = () => {
  const [tab, setTab] = useState<AutomationTab>("send");

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="h5" gutterBottom>
        🤖 Chat Automations
      </Typography>

      <Alert severity="warning" sx={{ mb: 2 }}>
        Heads up: this sends real messages and adds real members. Always Preview &amp; Match first,
        and double-check before you send. If something goes out by mistake, Recent Sends can take it
        back.
      </Alert>

      <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 2 }}>
        <Tab value="send" label="📨 Send Messages" />
        <Tab value="add" label="➕ Add Members" />
        <Tab value="recent" label="↩ Recent Sends" />
      </Tabs>

      {tab === "send" && <SendMessagesPanel />}
      {tab === "add" && <AddMembersPanel />}
      {tab === "recent" && <RecentSendsPanel />}
    </Box>
  );
};

export default ChatAutomationsPage;
